<div class="breadcrumb-container fx-col fx-jc-start fx-ai-start"  [ngClass]="'mat-body'">

  <div *ngIf="foldersStructure"
       class="folder-list">
    <div *ngIf="clearFilterButton"
         class="clear-filter-button">
      <button mat-button
              (click)="handleClearFilter()">
        <mat-icon>
          clear
        </mat-icon>
        &nbsp; Clear Filter
      </button>
    </div>
    <div *ngFor="let folder of getAllFolders()"
         class="folder-item"
         [ngClass]="{ 'highlight': folder.name === currentFolderName }"
         [ngStyle]="{ 'background-color': folder.name === currentFolderName ? folderColor : 'transparent' }"
         (click)="handleGo(folder.id)">
      <mat-icon class="material-icons"
                aria-hidden="false"
                aria-label="Folder icon"
                [ngStyle]="{ 'color': folder.color || '#757575' }">
        folder
      </mat-icon>
      <span>
        {{folder.name}}
      </span>
    </div>
  </div>
</div>
